import {twMerge} from "tailwind-merge";

export default function LargeRadioButton({options = [], classes = {}, onChange, active}) {

    const {parentClasses = "", itemClasses = ""} = classes;

    return (
        <div className={twMerge("w-full space-y-3", parentClasses)}>
            {
                options.map(item => (
                    <button
                        key={item.value}
                        onClick={() => onChange(item.value)}
                        className={twMerge(`w-full flex items-center text-right rounded-[1.125rem] border text-pol-dark-800 px-4 py-[1.05rem] hover:brightness-100 hover:border-pol-blue ${active === item.value ? "bg-pol-blue-light border-pol-blue" : "bg-white border-pol-blue-light"}`, itemClasses)}
                    >
                        <span className={`w-5 h-5 rounded-[0.313rem] ml-2.5 mt-1 flex-center ${active === item.value ? "bg-white" : "bg-pol-gray-light-9"}`}>
                            {active === item.value ? <i className="icon-tick text-xs text-pol-blue" /> : null }
                        </span>
                        {item.label}
                    </button>
                ))
            }
        </div>
    )
}
